module.exports = __webpack_public_path__ + "img/about-ob2.43b28a52.jpg";